// /* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
//  * Unauthorized copying of this file, via any medium is strictly prohibited
//  * Proprietary and confidential
//  * Written by Aetonix, Augest 28, 2018
//  * For information or permission request, email info@aetonixsystems.com
//  */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "ownstatus",
	init: init,
	uninit: uninit,
	listeners: listeners,
	refresh: refresh,
});

function init() {
	this.refresh();
	this.push({});
}

function uninit() {
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/workflow/status/updated": refresh,
		"mqtt:$/workflow/current_status/updated": refresh,
		"mqtt:$/observations/status/updated": refresh
	};
}

function refresh() {
	this.emit("save:trigger:start");

	return this.api.status.data()
		.then(set_status.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function set_status(data) {
	var oldData = this.data;
	if(data.current_status <= -1 && oldData.current_status > -1)
		this.dispatch("hidestatus");
	if(data.status) {
		var definitions = Object.keys(data.status).map(function(key) {
			return key.split(":")[0];
		});
		this.emit("workflowdefinitions:trigger:track", {
			definitions: definitions
		});
	}
	this.push(data);
}